import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import baseURL from "../../config";

// Styled Table Row for Alternating Colors
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
    cursor: "pointer",
  },
}));

const CompletedInvoices = ({ agentId }) => {
  const [completedPayments, setCompletedPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false); // 👈 Toggle state

  const fetchCompletedPayments = async () => {
    // If already shown, toggle it off
    if (showTable) {
      setShowTable(false);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${baseURL}/api/payment/getPaymentStatusCompletedCrewingAgentId/${agentId}`, {
        headers: { 
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      if (response.ok) {
        setCompletedPayments(data.payments);
        setShowTable(true);
      } else {
        console.error("Error fetching completed payments:", data.message);
      }
    } catch (error) {
      console.error("❌ Network Error:", error);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, pb: 4 }}>
      <Typography variant="h4" gutterBottom align="center" fontWeight="bold">
        Completed Payments
      </Typography>

      <Box display="flex" justifyContent="center" my={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchCompletedPayments}
          disabled={loading}
          sx={{ px: 3, py: 1.5, fontSize: "16px", fontWeight: "bold", backgroundColor: "#C30B12" }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : showTable ? (
            "Hide Completed Payments"
          ) : (
            "Show Completed Payments"
          )}
        </Button>
      </Box>

      {showTable && completedPayments.length > 0 && (
        <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#C30B12" }}>
              {/* <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Sr. No.</TableCell> */}
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Vessel Owner</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Crew</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {completedPayments.map((payment) =>
                payment.payments.map((p,index) => (
                  <StyledTableRow key={p._id}> 
                    <TableCell>{p.crewingAgentName}</TableCell>
                    <TableCell>{p.crewName}</TableCell>
                    <TableCell>₹{p.paymentAmount.toFixed(2)}</TableCell>
                    <TableCell>{p.paymentStatus}</TableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!loading && showTable && completedPayments.length === 0 && (
        <Typography align="center" sx={{ mt: 2, fontSize: "18px", fontWeight: "500", color: "gray" }}>
          No completed payments found.
        </Typography>
      )}
    </Container>
  );
};

export default CompletedInvoices;
